import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPayableAmount } from "../../store/slices/IdSlice";

const PaymentDetails: React.FC = () => {
  const dispatch = useDispatch();
  const discountAmount = sessionStorage.getItem("discountAmount");
  const tipValue = Number(sessionStorage.getItem("tipValue") || "0");
  const discount = Number(discountAmount);
  const {
    cartValuePrice: totalAmount,
    oldValueOfCartItems: oldTotalAmount,
    handlingAmt,
    convenienceAmt,
    totalPayableAmt,
  } = useSelector((store: any) => store.ID);

  const getAllFinalAmount = () => {
    const baseAmount = totalAmount - (discount || 0) + (tipValue || 0);
    const total = (
      baseAmount +
      parseFloat(handlingAmt?.toString() || "0") +
      parseFloat(convenienceAmt?.toString() || "0")
    ).toFixed(2);
    dispatch(setPayableAmount(total));
  };

  useEffect(() => {
    getAllFinalAmount();
  }, [totalAmount, discount, tipValue, handlingAmt, convenienceAmt]);

  return (
    <div className="payment-summary-container p-0  mb-2 ">
      <div className="payment-summary-header bg-2 px-3 py-2 mb-0 d-flex align-items-center gap-2">
        <img
          src="https://goodhand.b-cdn.net/Assets/Upload/payment-ico.svg"
          className="img-fluid"
          alt=""
        />
        <p className="payment-summary-title mb-0">Payment summary</p>
      </div>
      <div className="p-4 pt-2">
        {/* {oldTotalAmount > totalAmount && ( */}
        <div className="payment-summary-item d-none">
          <div className="d-flex justify-content-between">
            <p className="payment-summary-label">Actual Price</p>
            <p className="payment-summary-value">
              {/* <s className="ff-medium"> */}
              <span className="ff-currency ff-medium font-16"></span>
              {oldTotalAmount.toFixed(2) || 0}
              {/* </s> */}
            </p>
          </div>
        </div>
        {/* )} */}

        {totalAmount > 0 && (
          <div className="payment-summary-item">
            <div className="d-flex justify-content-between">
              <p className="payment-summary-label">Item total</p>
              <p className="payment-summary-value ">
                <span className="ff-currency ff-medium font-16"></span>
                {totalAmount.toFixed(2)}
              </p>
            </div>
          </div>
        )}
        {discount > 0 && (
          <div className="payment-summary-item">
            <div className="d-flex justify-content-between">
              <p className="payment-summary-label">Discount</p>
              <p className="payment-summary-value ">
                <span className="ff-currency ff-medium font-16"></span>
                {discount.toFixed(2) || 0}
              </p>
            </div>
          </div>
        )}

        <div className="payment-summary-item d-none">
          <div className="d-flex justify-content-between">
            <p className="payment-summary-label">Visitation Fee</p>
            <p className="payment-summary-value ">
              <span className="ff-currency ff-medium font-16"></span>
              {discount > 0 ? discount.toFixed(2) : 20}
            </p>
          </div>
        </div>
        {handlingAmt > 0 && (
          <div className="payment-summary-item">
            <div className="d-flex justify-content-between">
              <p className="payment-summary-label">Handling Fee</p>
              <p className="payment-summary-value ">
                <span className="ff-currency ff-medium font-16"></span>
                {handlingAmt > 0 ? handlingAmt.toFixed(2) : 25}
              </p>
            </div>
          </div>
        )}
        {convenienceAmt > 0 && (
          <div className="payment-summary-item">
            <div className="d-flex justify-content-between">
              <p className="payment-summary-label">Convenience Fee</p>
              <p className="payment-summary-value ">
                <span className="ff-currency ff-medium font-16"></span>
                {convenienceAmt > 0 ? convenienceAmt.toFixed(2) : 25}
              </p>
            </div>
          </div>
        )}
        <div className="payment-summary-item  d-none">
          <div className="d-flex justify-content-between">
            <div className="d-flex align-items-center gap-2">
              <div>
                {" "}
                <svg
                  width="11"
                  height="11"
                  viewBox="0 0 11 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.49966 0C5.9683 0 6.41714 0.187016 6.74661 0.518144L7.13055 0.902076C7.25408 1.02489 7.42114 1.09389 7.59533 1.09404H8.14538C8.6122 1.09404 9.0599 1.27949 9.38999 1.60958C9.72009 1.93967 9.90553 2.38737 9.90553 2.85419V3.40424C9.90553 3.57805 9.97484 3.74527 10.0964 3.86793L10.4803 4.25186C10.6447 4.41534 10.7752 4.60968 10.8642 4.82373C10.9533 5.03777 10.9992 5.2673 10.9993 5.49914C10.9994 5.73097 10.9537 5.96054 10.8648 6.17467C10.776 6.38879 10.6457 6.58325 10.4814 6.74687L10.0975 7.1308C9.97469 7.25433 9.90568 7.4214 9.90553 7.59559V8.14564C9.90553 8.61246 9.72009 9.06016 9.38999 9.39025C9.0599 9.72034 8.6122 9.90579 8.14538 9.90579H7.59533C7.42168 9.90594 7.25508 9.97451 7.13165 10.0967L6.74771 10.4806C6.58424 10.645 6.38989 10.7754 6.17585 10.8645C5.9618 10.9536 5.73227 10.9995 5.50044 10.9996C5.2686 10.9997 5.03903 10.954 4.82491 10.8651C4.61078 10.7762 4.41632 10.6459 4.2527 10.4817L3.86877 10.0978C3.74524 9.97494 3.57817 9.90594 3.40398 9.90579H2.85393C2.38711 9.90579 1.93941 9.72034 1.60932 9.39025C1.27923 9.06016 1.09378 8.61246 1.09378 8.14564V7.59559C1.09363 7.42194 1.02506 7.25534 0.902918 7.1319L0.518985 6.74797C0.3546 6.58449 0.224129 6.39015 0.135066 6.17611C0.046003 5.96206 0.000102391 5.73253 1.71109e-07 5.50069C-0.000102049 5.26886 0.0455962 5.03929 0.13447 4.82516C0.223345 4.61104 0.353644 4.41658 0.517885 4.25296L0.901818 3.86903C1.02463 3.7455 1.09363 3.57843 1.09378 3.40424V2.85419L1.09653 2.75408C1.1221 2.3053 1.3184 1.88331 1.64517 1.57464C1.97194 1.26597 2.40443 1.09402 2.85393 1.09404H3.40398C3.57763 1.09389 3.74423 1.02532 3.86767 0.903177L4.2516 0.519244C4.41515 0.354719 4.60961 0.224147 4.8238 0.135036C5.03798 0.0459253 5.26767 3.35947e-05 5.49966 0ZM6.86927 6.04446C6.65045 6.04446 6.44059 6.13139 6.28586 6.28612C6.13113 6.44085 6.0442 6.65071 6.0442 6.86953C6.0442 7.08835 6.13113 7.29821 6.28586 7.45294C6.44059 7.60767 6.65045 7.6946 6.86927 7.6946C7.0881 7.6946 7.29796 7.60767 7.45269 7.45294C7.60742 7.29821 7.69434 7.08835 7.69434 6.86953C7.69434 6.65071 7.60742 6.44085 7.45269 6.28612C7.29796 6.13139 7.0881 6.04446 6.86927 6.04446ZM7.53318 3.45539C7.43003 3.35227 7.29015 3.29435 7.1443 3.29435C6.99844 3.29435 6.85856 3.35227 6.75541 3.45539L3.45513 6.75567C3.35494 6.85941 3.2995 6.99835 3.30075 7.14258C3.302 7.2868 3.35985 7.42475 3.46183 7.52674C3.56382 7.62872 3.70178 7.68657 3.846 7.68782C3.99022 7.68907 4.12916 7.63363 4.2329 7.53344L7.53318 4.23316C7.6363 4.13001 7.69423 3.99013 7.69423 3.84428C7.69423 3.69842 7.6363 3.55854 7.53318 3.45539ZM4.11904 3.29423C3.90022 3.29423 3.69036 3.38116 3.53563 3.53589C3.3809 3.69062 3.29397 3.90048 3.29397 4.1193C3.29397 4.33812 3.3809 4.54798 3.53563 4.70271C3.69036 4.85744 3.90022 4.94437 4.11904 4.94437C4.33786 4.94437 4.54772 4.85744 4.70245 4.70271C4.85718 4.54798 4.94411 4.33812 4.94411 4.1193C4.94411 3.90048 4.85718 3.69062 4.70245 3.53589C4.54772 3.38116 4.33786 3.29423 4.11904 3.29423Z"
                    fill="#6E42E5"
                  />
                </svg>
              </div>
              <p className="payment-summary-label ">
                Discount Applied -{" "}
                <span className="ff-semibold discount">EIDSale30 </span>
              </p>
            </div>
            <p className="payment-summary-value discount ">
              <span className="ff-currency ff-medium font-16"></span> -{" "}
              {discount > 0 ? discount.toFixed(2) : 25}
            </p>
          </div>
        </div>

        {Number(tipValue) >= 5 && (
          <div className="payment-summary-item">
            <div className="d-flex justify-content-between">
              <p className="payment-summary-label">Tip</p>
              <p className="payment-summary-value ">
                {" "}
                <span className="ff-currency ff-medium font-16"></span>{" "}
                {tipValue}
              </p>
            </div>
          </div>
        )}

        <div className="payment-summary-item pt-3">
          <div className="d-flex justify-content-between">
            <p className=" font-13 text-black ff-bold mb-0">Amount to pay</p>
            <p className="font-13 text-black ff-bold mb-0">
              <span className="ff-currency ff-medium font-16"></span>{" "}
              {Number(totalPayableAmt).toFixed(2)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentDetails;
